export const agreementDoc = {
  fontFamily: "Arial",
  paragraph: {
    fontSize: "16px", // Word's 12pt converted to 16px
    lineHeight: 1.15, // closest approximation to Word's line spacing 1.0
    textAlign: "justify",
  },
  textBlock: {
    spacing: "16px",
  },
};
